import {
    SET_NAVIGATION
} from './types';

const initialNavigation = {
    navigationTab: ""
};

const reducers = (state = initialNavigation, action: any) => {
    if (action.type == SET_NAVIGATION) {
        return {
            ...state, ...action.navigationTab
        }
    }
    else {
        return state;
    }
};

export default reducers;
